// extracted by mini-css-extract-plugin
export default {"container":"CallHistoryOrderTab_container__aGpKv","noData":"CallHistoryOrderTab_noData__sp-1n","viewHeader":"CallHistoryOrderTab_viewHeader__qN9bG"};